/* ============================================================
   PRAXIS — <praxis-tabs>
   Client-side tab switcher for the featured-collection tabs.
   Panels are all rendered server-side; this only toggles which
   one is visible (ARIA tablist pattern). No AJAX, no cart logic.
   ============================================================ */
(function () {
  if (customElements.get('praxis-tabs')) return;

  class PraxisTabs extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      if (this.tabs.length < 2) return; // one (or zero) collection — nothing to switch

      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.activate(i));
        tab.addEventListener('keydown', (e) => this.onKeydown(e, i));
      });

      // Theme editor: reveal the panel whose tab block the merchant selects.
      if (window.Shopify && window.Shopify.designMode) {
        this.addEventListener('shopify:block:select', (e) => {
          const tab = e.target.closest('[role="tab"]');
          const i = this.tabs.indexOf(tab);
          if (i > -1) this.activate(i);
        });
      }
    }

    activate(i) {
      this.tabs.forEach((tab, j) => {
        const selected = j === i;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.setAttribute('tabindex', selected ? '0' : '-1');
        tab.classList.toggle('is-active', selected);
      });
      this.panels.forEach((panel, j) => {
        panel.hidden = j !== i;
        panel.classList.toggle('is-active', j === i);
      });
    }

    onKeydown(e, i) {
      const last = this.tabs.length - 1;
      let next = null;
      switch (e.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          next = i === last ? 0 : i + 1;
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          next = i === 0 ? last : i - 1;
          break;
        case 'Home':
          next = 0;
          break;
        case 'End':
          next = last;
          break;
        default:
          return;
      }
      e.preventDefault();
      this.activate(next);
      this.tabs[next].focus();
    }
  }

  customElements.define('praxis-tabs', PraxisTabs);
})();
